import React from 'react'
import SafeSpace from 'redesign/components/atoms/SafeSpace'
import FooterWrapper from 'redesign/components/atoms/footer-wrapper'
import HamburgerHeader from 'redesign/components/molecules/HamburgerHeader'
import SideMenuNavigation from 'redesign/components/templates/NavigationSideMenu'
import { isNative } from 'utils/platform'
import NavigationBar from '../NavigationBar'
// TODO: Apply when redesign is finished for accessibility reasons
// import '@ionic/react/css/core.css'
// import '@ionic/react/css/normalize.css'
// import '@ionic/react/css/typography.css'
import { Content, ContentContainer, HeaderWrapper } from './styles'
import type { PageProps } from './types'
import usePage from './use-page'

const Page: React.FC<PageProps> = (props) => {
  const {
    children,
    header,
    backgroundColor,
    footer,
    center = false,
    flex = false,
    paddingX = 0,
    noPadding,
    columnCenter,
    fitToViewport,
    growContent = true,
    hasFloatingButtons,
    removeLastMargin,
    fullContentWidth = false,
    fullContentHeight = false,

    rootId,
  } = props
  const {
    displayHamburgerHeader,
    displayMenu,
    extraBotMargin,
    hideSidePanel,
    showSidePanel,
    toggleDrawer,
    isSmallNativeScreen,
    removePaddingBottom,
    theme,
    auth,
    isOpen,
    hasNavbar,
  } = usePage(props)

  return (
    <>
      <SideMenuNavigation
        toggleDrawer={toggleDrawer}
        displayMenu={displayMenu}
        auth={auth}
        showHamburgerHeader={displayHamburgerHeader}
      />
      <SafeSpace rootId={rootId} removePaddingBottom={removePaddingBottom}>
        {displayHamburgerHeader && (
          <HamburgerHeader
            toggleMenu={toggleDrawer}
            showHamburger
            showLogo
            hamburguerTestId="hamburger-header"
            menuButtonTestId="navigation-icon"
          />
        )}
        {Boolean(header) && <HeaderWrapper>{header}</HeaderWrapper>}
        <ContentContainer
          no-bounce
          has-bouncing="false"
          forceOverscroll={false}
          id="ionContent"
          backgroundColor={backgroundColor ?? theme.palette.background.default}
        >
          <Content
            isFlex={flex}
            paddingX={paddingX}
            center={center}
            growContent={growContent}
            columnCenter={columnCenter}
            fitToViewport={fitToViewport}
            fullContentHeight={fullContentHeight}
            isOpen={isOpen}
            fullContentWidth={fullContentWidth}
            removeLastMargin={removeLastMargin}
            hasFloatingButtons={hasFloatingButtons}
            addSafeMargin={!header}
            noPadding={noPadding}
            extraBottomMargin={extraBotMargin}
            isNative={isNative() && isSmallNativeScreen}
          >
            {children}
          </Content>
        </ContentContainer>
        {Boolean(footer) && <FooterWrapper>{footer}</FooterWrapper>}
        {hasNavbar && (
          <NavigationBar isMenuActive={displayMenu} showSidePanel={showSidePanel} hideSidePanel={hideSidePanel} />
        )}
      </SafeSpace>
    </>
  )
}

export default Page
